<template>
  <div class="header">
    <!-- <el-button style="margin-left:100px" type @click="red()">这是一个测试</el-button> -->
    <div class="row">
      <a href="/home.html">
        <img src="../../module/home/img/logo.png" height="60" class="logo" alt="海南涉外民商事法庭案件多元化解平台" />
      </a>
      <ul class="nav clearfix">
        <li v-for="(item, index) in navlist" v-bind:key="item.id" :class="{ on: index === navindex }">
          <span v-if="item.tit == '法律法规案例库'">
            <el-dropdown placement="bottom" style="height: 75px; top: 1px" @command="handleCommand">
              <span class="el-dropdown-link flfg" :class="lang == 'en_US' ? 'enwidth' : ''"> 法律法规案例库 </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="法律法规案例库">涉外民商事案例库</el-dropdown-item>
                <el-dropdown-item command="法规案例扩展库">涉外民商事知识库</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <a href="javascript:;" :class="lang == 'en_US' ? 'enwidth' : ''" @click="lawMore(item.url)"
            v-else-if="index === 1">{{ item.tit }}</a>
          <a :href="item.url" :class="lang == 'en_US' ? 'enwidth' : ''" v-else>{{ item.tit }}</a>
        </li>
      </ul>
      <!-- <el-dropdown trigger="click" style="float: right">
          <span class="el-dropdown-link">
            {{$t('other.language')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toggleLang('zh_CN')" :disabled="lang == 'zh_CN'">中文</el-dropdown-item>
            <el-dropdown-item @click.native="toggleLang('en_US')" :disabled="lang == 'en_US'">English</el-dropdown-item>
            <el-dropdown-item @click.native="toggleLang('zh_TW')" :disabled="lang == 'zh_TW'">繁体</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
    </div>
  </div>
</template>
<script>
import { getStore } from '@/publicResource/utils/utils.js'
import config from '@/publicResource/config/config.js'
import robot from '@/publicResource/config/robot'
export default {
  data() {
    return {
      navlist: [],
      lang: '',
      robot: robot,
      currentLa: ''
    }
  },
  props: ['navindex'],
  mounted() {
    if (getStore('loginInfouser') === null) {
      // this.navlist.splice(3, 1);
    }
    this.lang = localStorage.getItem('locale')
    let currentLa = ''
    if (this.lang === 'en_US') {
      currentLa = 'en'
    } else if (this.lang == 'zh_TW') {
      currentLa = 'tc'
    } else {
      currentLa = 'zh'
    }
    this.currentLa = currentLa
    this.navlist = [
      {
        tit: this.$t('header.home'),
        url: '/home.html'
      },
      {
        tit: this.$t('header.regulatoryCase'),
        url: 'https://law.odrcloud.cn/gd-fa/index'
        // url: config.searchCaseUrl + '/?lang=' + currentLa + '#/'
      },
      {
        tit: this.$t('header.LegalAdvice'),
        url: '/ailegal.html'
      },
      // {
      //   tit: this.$t('header.lawsAndRegulations'),
      //   url: '/law.html#/lawSearch'
      // },
      // {
      //   tit: this.$t('header.caseLibrary'),
      //   url: '/case.html#/caseSearch'
      // },
      {
        tit: this.$t('header.resourceDatabase'),
        url: '/service.html'
      },
      {
        tit: this.$t('header.helpCenter'),
        url: '/help.html#/help'
      },
      {
        tit: this.$t('header.mediationCentre'),
        url: '/meeting.html#/invite'
      }
    ]
  },
  methods: {
    // x
    toggleLang(lang) {
      if (lang == 'zh_CN') {
        localStorage.setItem('locale', 'zh_CN')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切换为中文！',
          type: 'success'
        })
      } else if (lang == 'en_US') {
        localStorage.setItem('locale', 'en_US')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: 'Switch to English!',
          type: 'success'
        })
      } else if (lang == 'zh_TW') {
        localStorage.setItem('locale', 'zh_TW')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切換為中文！',
          type: 'success'
        })
      }
      window.location.reload()
    },
    lawMore(url) {
      window.open(url)
    },
    handleCommand(command) {
      // if(command == "法律法规案例库"){
      //   const url = config.searchCaseUrl + '/?lang=' + this.currentLa + '#/'
      //   window.open(url)
      // }else{
      //   window.open("https://law.odrcloud.cn/gd-fa/index")
      // }
      window.open('https://law.odrcloud.cn/gd-fa/index')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 85px;
  line-height: 85px;
  background-color: #fff;
  overflow: hidden;
  width: 100%;

  .row {
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      height: 85px;
      display: flex;
      align-self: center;
      margin-top: 20px;
    }
  }

  .logo {
    display: block;
    /*position: absolute;*/
    /*top: 16px;*/
    /*width: 500px;*/
    /*height: 58px;*/
    // left: -4%;
    // top: 18px;
    // width: 380px;
    // height: 45px;
  }

  .nav {
    /*float: right;*/
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    height: 85px;

    li {
      float: left;
      margin-left: 24px;
      /*width: 60px;*/
      text-align: center;

      a,
      .flfg {
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      .flfg {
        line-height: 123px;
        display: inline-block;
        height: 85px;
      }

      .enwidth {
        /*width: 160px;*/
        display: flex;
        justify-content: center;
        white-space: nowrap;
      }

      &.on {
        a {
          color: #3595f4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/publicResource/components/header.vue